/**
 * CSV formula-injection guard (OWASP): prefix a single quote to any string cell starting with
 * = + - @ TAB or CR. MJ's CSVExporter.escapeCSVValue has no guard and is private
 * (export-engine/dist/csv-exporter.js:73-85, csv-exporter.d.ts:21), so rows are neutralized
 * before they reach ExportEngine.toCSV. Upstream defect recorded in the OEP plan index.
 */
export function NeutralizeFormulaCells<T extends Record<string, string | number | boolean | null>>(rows: readonly T[]): T[] {
    return rows.map((row) => {
        const out: Record<string, string | number | boolean | null> = {};
        for (const [k, v] of Object.entries(row)) out[k] = typeof v === 'string' && /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
        return out as T;
    });
}
